import React, { useEffect } from 'react';
import { Col, Form, Input, Row, Space, Switch, theme } from 'antd';

interface IDeviceFilterFormProps {
  keywords: string;
  onFilter: (keywords: string, syncWithMap: boolean) => void;
}

const DeviceFilterForm: React.FC<IDeviceFilterFormProps> = ({keywords, onFilter}) => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    borderRadius: token.borderRadiusLG,
  };

  useEffect(() => {
    form.setFieldsValue({ filterBy: keywords });
  }, [form, keywords]);

  const dofilter = () => {
    onFilter(form.getFieldValue('filterBy'), form.getFieldValue('syncWithMap'));
  }

  const getFields = () => {
    return [
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={12}
        key='filterBy'
        style={{ padding: 10}}
      >
        <Form.Item
          name='filterBy'
          label='Filter By'
          style={{ margin: 0 }}
        >
          <Input
            allowClear
            placeholder='Serial, Name, Address, Device Type, Device ID or Network ID.'
            onChange={e => dofilter()}
          />
        </Form.Item>
      </Col>,
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={12}
        key='sync'
        style={{ padding: 10}}
      >
        <Space>
          <Form.Item name='syncWithMap' style={{ margin: 0 }}>
            <Switch
              checkedChildren="Sync with Map"
              unCheckedChildren="Sync with Map"
              defaultChecked
              onChange={dofilter}
            />
          </Form.Item>
        </Space>

      </Col>,
    ];
  };

  return (
    <Form form={form} name="device_filter" style={formStyle} initialValues={{ syncWithMap: true, filterBy: '' }}>
      <Row gutter={24} style={{ marginLeft: 0, marginRight: 0 }}>{getFields()}</Row>
    </Form>
  );
};

export default DeviceFilterForm;